import { action } from 'typesafe-actions';
import ActionTypes from './constants';
import { Language } from 'i18n';

export function changeLocale(locale: Language) {
  return action(ActionTypes.CHANGE_LOCALE, { locale });
}
